import { useEffect } from "react";
export const useGenerateBvh = ({ id, sgwc, bvhwc }, cb) => {
    useEffect(() => {
        bvhwc?.onBvhGeneration(id, cb);
        sgwc?.onStaticGeometryChange(id, staticGeometry => {
            bvhwc?.bvhGeneration(staticGeometry, id, !!bvhwc?.running);
        });
    }, []);
};
